import _ from 'lodash';
import PropTypes from 'prop-types';
import { createSelector } from 'reselect';

const getUserData = store => _.get(store, 'common.user');
const getCreditCards = store => _.get(store, 'accountSettings.creditCards');
const getStoreCredit = store => _.get(store, 'accountSettings.availableCredit');
const getOrderHistory = store => _.get(store, 'accountSettings.purchaseHistory');

export const getUser = createSelector(
  getUserData,
  user => user,
);

export const getBasicAccountInfo = createSelector(
  getUser,
  user => ({
    first_name: user.first_name,
    last_name: user.last_name,
    display_name: user.display_name,
    email: user.email,
    phone: user.phone,
  }),
);

export const getPaymentMethods = createSelector(
  getCreditCards,
  getStoreCredit,
  (creditCards, storeCredit) => ({ creditCards, storeCredit }),
);

export const getPurchaseHistory = createSelector(
  getOrderHistory,
  purchaseHistory => purchaseHistory,
);

export const userPropTypes = {
  id: PropTypes.number,
  email: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  display_name: PropTypes.string,
};

export const creditCardsPropType = {
  name: PropTypes.string,
  lastDigits: PropTypes.string.isRequired,
  cc_type: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
  month: PropTypes.string.isRequired,
};

export const storeCreditPropType = {
  design: PropTypes.string,
  glowforge: PropTypes.string,
  shop: PropTypes.string,
  all: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/selectors/user.js